export { default } from "./ShareIcon";
